import React, { useState } from 'react';
import { stepDefs } from '../data';
import {
  Dot,
  StepHintDot,
  StepHintPop,
  StepHintWrap,
  StepLabel,
  StepRow,
  StepperBox,
  StepperHeading,
} from './styles';

interface StepperProps {
  currentStep: number;
  variant: 'ov' | 'wb';
}

const StepHint: React.FC<{ hint: string }> = ({ hint }) => {
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);

  return (
    <StepHintWrap
      onMouseEnter={e => {
        const r = e.currentTarget.getBoundingClientRect();
        setPos({ top: r.top + r.height / 2, left: r.right + 10 });
      }}
      onMouseLeave={() => setPos(null)}
    >
      <StepHintDot>i</StepHintDot>
      <StepHintPop $visible={!!pos} $top={pos?.top || 0} $left={pos?.left || 0}>
        {hint}
      </StepHintPop>
    </StepHintWrap>
  );
};

const Stepper: React.FC<StepperProps> = ({ currentStep, variant }) => (
  <StepperBox>
    <StepperHeading>So geht&rsquo;s</StepperHeading>
    {stepDefs.map(s => {
      const done = s.n < currentStep;
      const active = s.n === currentStep;
      const mark = done ? '✓' : String(s.n);
      const showHint = !!s.hint && active && variant === 'wb';
      return (
        <StepRow key={s.n} $done={done} $active={active} $opt={s.opt}>
          <Dot $done={done} $active={active}>
            {mark}
          </Dot>
          <StepLabel>{s.label}</StepLabel>
          {showHint && <StepHint hint={s.hint as string} />}
        </StepRow>
      );
    })}
  </StepperBox>
);

export default Stepper;
